<sd-title [titleLevel]="1">{{ title }}</sd-title>

<ul class="left-column">
  @for (url of currentNavigation; track url) {
    <li>
      <a [routerLink]="[]" [fragment]="url?.name"> {{ url?.title }}</a>
    </li>
  }
</ul>
